import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='adyenKlarna' subtitle='object' mdxType="Item">
	Options for using Klarna via Adyen as a payment method.
	<Group summary='Properties' mdxType="Group">
        <Item title='buttonOptions' subtitle='object' mdxType="Item">
          <p>{`Options for Klarna button.`}</p>
          <Group summary='Properties' mdxType="Group">
            <Item title='text' subtitle='string' mdxType="Item">
              <p>{`Text to be displayed next to the Klarna logo. If provided, it will replace the default `}<inlineCode parentName="p">{`Pay with`}</inlineCode>{` text.`}</p>
            </Item>
          </Group>
        </Item>
	</Group>
    </Item>
    <Item title='klarna' subtitle='object' mdxType="Item">
	Options for using Klarna as a payment method.
	<Group summary='Properties' mdxType="Group">
		<Item title='paymentFlow' subtitle='"DEFAULT" | "PREFER_VAULT"' mdxType="Item">
			The payment flow of the Klarna payment method.
		</Item>
		<Item title='recurringPaymentDescription' subtitle='string' mdxType="Item">
			The description of the recurring payment.
		</Item>
		<Item title='allowedPaymentCategories' subtitle='("pay_now" | "pay_later" | "pay_over_time")[]' mdxType="Item">
			An array of string values that specify the allowed payment categories.
		</Item>
        <Item title='buttonOptions' subtitle='object' mdxType="Item">
          <p>{`Options for Klarna button.`}</p>
          <Group summary='Properties' mdxType="Group">
            <Item title='text' subtitle='string' mdxType="Item">
              <p>{`Text to be displayed next to the Klarna logo. If provided, it will replace the default `}<inlineCode parentName="p">{`Pay with`}</inlineCode>{` text.`}</p>
            </Item>
          </Group>
        </Item>
	</Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      